import React from 'react';
import Layout from '../layouts/index';
import companies from '../assets/img/companies.jpg';

export default function AboutPage() {
	return (
		<Layout>
			<article className="entry">
				<div className="container">
					<div className="entry-inner">
						<div className="entry-content">
							<div className="container-sm">
								<header className="entry-header">
									<h1 className="entry-title">About</h1>
								</header>

								<div className="entry-body">
									<p>
										At 24dB we use our years of experience working in games,
										tech and business to solve everyday problems.
									</p>
									<p>
										Many years working in design, development and user
										experience make us the perfect team to develop initial ideas
										into working solutions.
									</p>
									{/* 									<hr />
									<p>
										Live demo:{' '}
										<a href="https://demo.cruip.com/holly/">
											https://demo.cruip.com/holly/
										</a>
									</p>
									<hr />
									<p>This template is distributed under the MIT License.</p> */}
								</div>
							</div>
						</div>
						<div className="entry-media">
							<img src={companies} alt="" />
						</div>
					</div>
				</div>
			</article>
		</Layout>
	);
}
